import { Divider, Grid, Typography } from '@mui/material'
import React, { useState } from 'react'
import CardInfo from './CardInfo';
import EditAndPreview from './EditAndPreview';


const CardInfoWrapper = ({ title, details, onEdit, loading, onSuccess, updateSystemAnnouncementDetails,systemAnnouncementData }) => {
const [editAndPreviewMessage, setEditAndPreviewMessage] = useState({ open: false, data: null,});


    return (
        <div>
            <Typography
                variant="h6"
                sx={{
                    px: 2,
                    py: 1.5
                }}>
                {title}
            </Typography>
            <Divider />
            <Grid container sx={{
                py: 1
            }}>
                {details?.map((item) => {
                    return <CardInfo
                        key={item.title}
                        item={item}
                        handleEditSystemAnnouncementModal={onEdit}
                        setEditAndPreviewMessage={setEditAndPreviewMessage}
                        updateSystemAnnouncementDetails={updateSystemAnnouncementDetails}
                    />
                })}
            </Grid>
            {editAndPreviewMessage.open && (
                <EditAndPreview
                    editAndPreviewMessage={editAndPreviewMessage}
                    setEditAndPreviewMessage={setEditAndPreviewMessage}
                    onSuccess={onSuccess}
                    loading={loading}
                    systemAnnouncementData={systemAnnouncementData}
                />
            )}
        </div>
    )
}

export default CardInfoWrapper
